import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import {
  Section,
  Heading,
  SectionHeader,
  Paragraph,
  Button,
} from 'components';

class Problem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFullDescriptionShown: false,
    };
  }

  toggleHiddenDescription = () =>
    this.setState(prevState => ({
      isFullDescriptionShown: !prevState.isFullDescriptionShown,
    }));

  render() {
    const { isFullDescriptionShown } = this.state;

    return (
      <Section color={'red'}>
        <Row className={'no-gap anim-fade-in-bottom'}>
          <Col sm={12} md={6}>
            <SectionHeader
              size={'big'}
              color={'white'}
              lineColor={'pigeon-post'}
              headingType={2}
            >
              Problem
            </SectionHeader>
          </Col>
          <Col sm={12} md={6}>
            <div className={'development-teams__problem-description'}>
              <Heading color={'white'} size={'medium-plus'} type={3}>
                I need a development team to deliver a user-centered digital
                product to market quickly and help my company grow while
                optimizing the costs.
              </Heading>
              {isFullDescriptionShown && (
                <Paragraph
                  additionalClass={
                    'development__additional-description text--light'
                  }
                  size={'medium'}
                  color={'white'}
                >
                  There are many reasons why businesses need development teams.
                  Some of them struggle to recruit experienced developers and
                  talented designers, others need a fresh take on their product
                  or simply a helping hand in times of rapid growth with a
                  temporary extension of their in-house dev team.
                </Paragraph>
              )}
              <div
                className={'development-teams__learn-more-button'}
                onClick={this.toggleHiddenDescription}
              >
                <Button
                  order={'secondary'}
                  color={'white'}
                  arrowColor={'pigeon-post'}
                >
                  {isFullDescriptionShown ? 'Show less' : 'Learn more'}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Section>
    );
  }
}

export default Problem;
